<template>
  <div v-show="isShow.isPTShow" class="pageTwo">
    <div class="dec-bottom"></div>
    <div class="img-wrapper scaleToShow">
      <img :src="myGotSrc" alt="">
      <p class="para shine">长按保存海报</p>
    </div>
    <div class="dec-up"></div>
    <div class="btn-group">
      <button class="left btn" @click="playAgain"></button>
      <button class="right btn" @click="showMask"></button>
    </div>
    <div class="mask" v-show="isMaskShow" @click="hideMask">
      <div class="share slideIn"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  props: {
    isShow: {
      type: Object
    },
    gotImgSrc: {
      type: String
    },
    myGotSrc: {
      type: String
    }
  },
  data() {
    return {
      isMaskShow: false
    }
  },
  methods: {
    showNext () {
      this.isShow.isPTShow = false
      this.isShow.isKVShow = true
    },
    showMask() {
      this.isMaskShow = true;
    },
    hideMask() {
      this.isMaskShow = false;
    },
    playAgain() {
      window.location.href = 'https://www.jiandoukeji.com/h5/2019/dreamwedding';
    }
  }
}
</script>

<style lang="less" scoped>
.pageTwo {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f9ede1;
  .dec-up {
    position: absolute;
    top: 0;
    right: 0;
    width: 8.125rem /* 130/16 */;
    height: 11.875rem /* 190/16 */;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('./img/fn-cloth.png');
  }
  .dec-bottom {
    position: absolute;
    bottom: 0;
    width: 23.4375rem /* 375/16 */;
    height: 5.84375rem /* 93.5/16 */ * .9;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('./img/fn-b-flower.png');
  }
  .img-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32.1875rem /* 515/16 */ * .9;
    width: 18.75rem /* 300/16 */ * .9;
    margin-top: -3.125rem /* 50/16 */;
    box-sizing: border-box;
    padding: 1%;
    background-color: #fff;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2);
    transition: all .6s ease;
    img {
      width: 100%;
      height: 100%;
    }
    .para {
      position: absolute;
      bottom: -1.25rem /* 20/16 */;
      font-size: .625rem /* 10/16 */;
      color: #999;
      letter-spacing: 1px;
    }
  }
  .btn-group {
    position: absolute;
    box-sizing: border-box;
    bottom: 2.25rem /* 36/16 */;
    width: 100%;
    padding: 0 18%;
    display: flex;
    justify-content: space-between;
    .btn {
      width: 6.6875rem /* 107/16 */;
      height: 2.40625rem /* 38.5/16 */;
      padding: unset;
      border: unset;
      background-color: transparent;
      background-size: cover;
      background-repeat: no-repeat;
    }
    .left {
      background-image: url('./img/btn-l.png');
    }
    .right {
      background-image: url('./img/btn-r.png');
    }
  }
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .6);
    z-index: 10;
    .share {
      position: absolute;
      right: 1.25rem /* 20/16 */;
      top: 1.25rem /* 20/16 */;
      width: 18.6875rem /* 299/16 */;
      height: 13.5625rem /* 217/16 */;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url('./img/fn-up-mask.png');
    }
  }
}

.shine {
  animation: shine 1s ease-in infinite;
  animation-delay: 1s;
  animation-fill-mode: both;
}

@keyframes shine {
  0% {
    opacity: 0;
  }
  60%, 100% {
    opacity: 1;
  }
}

.slideIn {
  animation: slideIn .4s ease-in;
  animation-fill-mode: both;
  animation-delay: .2s;
}

@keyframes slideIn {
  0% {
    transform: scale(.4);
    opacity: 0;
  }
  30% {
    transform: scale(1.06);
    opacity: 1;
  }
  38% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}

.scaleToShow {
  animation: scaleToShow 1s ease-in;
}

@keyframes scaleToShow {
  from {
    opacity: 0;
    transform-origin: center;
    transform: scale(.4);
  }
  to {
    opacity: 1;
    transform-origin: center;
    transform: scale(1);
  }
}

@media (max-device-height:568px) and (-webkit-min-device-pixel-ratio:2){/* 兼容iphone5*/
  .img-wrapper {
    transform-origin: center;
    transform: scale(.92);
  }
}

@media only screen and (min-height: 550px) and (max-height: 600px)  { /*iphone6和iphone6 s 兼容底部白条*/
  .img-wrapper {
    transform-origin: center;
    transform: scale(.92);
  }
}

@media only screen and (min-height: 610px) and (max-height: 640px)  { /*iphone6 plus 兼容底部白条*/
  .img-wrapper {
    transform-origin: center;
    transform: scale(.92);
  }
}
</style>
